import {CommonModule} from '@angular/common';
import {NgModule, Optional} from '@angular/core';
import {
  LF_APP_PRINT_TEMPLATES,
  LF_AT_THEME_SERVICES,
  LF_AT_XML_SERIALIZER_OPTIONS,
  LfAtSchema,
  LfAtThemeModule
} from 'lf-at-theme';
import {LF_APP_I18N, LF_APP_SCHEMA, LF_CORE_SERVICES, LF_ROUTER_BASE_PATH} from '@lightweightform/core';

import {XML_SERIALIZER_OPTIONS} from '../shared';
import {AppRoutingModule} from './app-routing.module';
import {appSchema} from './app.schema';
import {I18N_IMPORT} from './app.i18n';
import {ImportFormComponent} from './import-form/import-form.component';
import {ImportComponent} from './import.component';
import {ROUTER_BASE_PATH} from './tokens';


/** Module to be imported into other apps */
@NgModule({
  declarations: [
    ImportComponent,
    ImportFormComponent
  ],
  imports: [
    CommonModule,
    LfAtThemeModule.forChild(),
    AppRoutingModule
  ],
  providers: [
    LF_CORE_SERVICES,
    LF_AT_THEME_SERVICES,
    {provide: LF_AT_XML_SERIALIZER_OPTIONS, useValue: XML_SERIALIZER_OPTIONS},
    {provide: LF_APP_PRINT_TEMPLATES, useValue: {}},
    {provide: LF_APP_SCHEMA, useValue: LfAtSchema.schema(appSchema, false)},
    {provide: LF_APP_I18N, useValue: I18N_IMPORT},
    {provide: LF_ROUTER_BASE_PATH, useFactory: v => v, deps: [[new Optional(), ROUTER_BASE_PATH]]},
  ],
  exports: [
    ImportComponent,
  ]
})
export class ImportFormModule {
}
